import { skillIcons } from "@/data/icons"
import { portfolioData } from "@/data/portfolioData"
import { formatExperienceDate } from "@/lib/utils"
import { Badge } from "@/components/ui-lab/badge"
import { Card, CardContent } from "@/components/ui-lab/card"
import { FaRocket } from "react-icons/fa"
import { TagIcon } from "../custom/Tag"

export const MyExperience = () => {
  const { experience } = portfolioData

  return (
    <>
      <h2 className="text-3xl font-semibold mb-6 flex items-center gap-2" suppressHydrationWarning>
        <FaRocket /> Professional Experience
      </h2>
      <Card className="shadow-lg hover:shadow-2xl transition-all duration-300">
        <CardContent className="p-6 sm:pr-10 sm:pt-10">
          <ol className="relative ml-2">
            {experience.map((exp, idx) => (
              <li key={`${exp.company}-${exp.start_date}`} className="relative pl-8 pb-8 last:pb-0">
                {idx < experience.length - 1 && (
                  <span className="absolute left-[5px] top-4 bottom-0 w-0.5 bg-border" aria-hidden="true" />
                )}
                <span
                  className="absolute left-0 top-2 h-3 w-3 rounded-full border-2 border-primary bg-background"
                  aria-hidden="true"
                />
                <div
                  className="transition-all duration-300 hover:bg-gray-50 dark:hover:bg-gray-800/50 p-4 rounded-lg h-full shadow-lg hover:shadow-2xl hover:-translate-y-1 hover:border-teal-500 border-2 border-transparent"
                  suppressHydrationWarning
                >
                  <p className="text-xl font-semibold text-teal-700 dark:text-teal-400 block mb-0 italic">
                    {formatExperienceDate(exp.start_date, exp.end_date)}
                  </p>
                  <h3 className="text-2xl font-semibold mb-1 mt-2">{exp.role}</h3>
                  <span className="font-semibold text-muted-foreground">{exp.company}</span>
                  {exp.description && <p className="mt-2 mb-4">{exp.description}</p>}
                  {exp.achievements && exp.achievements.length > 0 && (
                    <div className="mt-2">
                      <span className="font-semibold text-sm">Key Achievements:</span>
                      <ol className="mt-1 ml-4 text-sm">
                        {exp.achievements.map((achievement, i) => (
                          <li key={i} className="mb-1">
                            {i + 1}. {achievement}
                          </li>
                        ))}
                      </ol>
                    </div>
                  )}
                  {exp.technologies && exp.technologies.length > 0 && (
                    <div className="flex flex-wrap gap-2 mt-3">
                      {exp.technologies.map((tech) => (
                        <Badge
                          key={tech}
                          variant="tech"
                          className="font-normal cursor-default transition-all duration-300 hover:scale-110 hover:shadow-md"
                        >
                          <TagIcon text={tech} icon={skillIcons[tech]} />
                        </Badge>
                      ))}
                    </div>
                  )}
                </div>
              </li>
            ))}
          </ol>
        </CardContent>
      </Card>
    </>
  )
}
